<template>
  <div class="basic-member-center" ref="wrapper">
    <div class="tooptipPart module_edit_btn">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="changeStyle('style')"></my_hover_btn>
      <my_close_btn v-if="false" :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="img-wrapper" v-if="isMobile">
      <img :src="infor.img" :alt="$t('router_default_92')">
      <div
        class="tooptipPart"
        style="top: initial; bottom: 0;"
      >
        <my_hover_btn :tips="$t('widgets_basic_banner_index_439')" btnIcon="el-icon-edit" @changeStyle="onClickEditImgBtn"></my_hover_btn>
      </div>
    </div>
    <div class="main-wrapper">
      <h3 class="page-title" :style="titleStyle">
        {{ listArr.title }}
      </h3>
      <div class="content-wrapper">
        <div class="tab-nav">
          <div v-for="tab in tabList"
               :class="`tab-item tab-item-${tab.key} ${currentTab===tab.key?'tab-item-active':''}`"
               :style="currentTab===tab.key?activeTabStyle:tabStyle" :data-name="tab.key"
               @click="onClickTabItem(tab.key)">
            {{ tab.name }}
          </div>
        </div>
        <div class="tab-content-wrapper">
          <div class="tab-panel tab-panel-profile tab-panel-active">
            <tab-profile></tab-profile>
          </div>
          <div class="tab-panel tab-panel-password">
            <tab-password></tab-password>
          </div>
          <div class="tab-panel tab-panel-points">
            <tab-points></tab-points>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import tabProfile from './components/tab-profile'
import tabPassword from './components/tab-password'
import tabPoints from './components/tab-points'

export default {
  name: "basic_member_center_index",
  components: {
    tabProfile,
    tabPassword,
    tabPoints
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tabList: [{
        name: i18n.t('widgets_basic_member_center_index_2624'),
        key: 'profile'
      }, {
        name: i18n.t('widgets_basic_member_center_index_2625'),
        key: 'password'
      }, {
        name: i18n.t('widgets_basic_member_center_components_tab_points_2606'),
        key: 'points'
      }],
      currentTab: 'profile'
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.app.view_pattern === 'mb'
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor']
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
      return this.module.data.mb_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    titleStyle() {
      return this.$utils.getFontStyle(this.pc_widgets_infor.titleFont)
    },
    labelStyle() {
      return this.$utils.getFontStyle(this.pc_widgets_infor.labelFont)
    },
    contentStyle() {
      let style = {
        ...this.$utils.getFontStyle(this.pc_widgets_infor.contentFont),
      }
      if (this.pc_widgets_infor.moduleStyle === 1) {
        style = {
          ...style,
          ...this.$utils.getBackground(this.pc_widgets_infor.background),
        }
      }
      return style
    },
    buttonStyle() {
      return {
        ...this.$utils.getBackground(this.pc_widgets_infor.buttonBackground),
        ...this.$utils.getFontStyle(this.pc_widgets_infor.buttonFont),
        ...this.$utils.getBorderRadiusStyle(this.pc_widgets_infor.buttonBorderRadius),
      }
    },
    tabStyle() {
      return {
        ...this.$utils.getBackground(this.pc_widgets_infor.tabBackground),
        ...this.$utils.getFontStyle(this.pc_widgets_infor.tabFont),
      }
    },
    activeTabStyle() {
      return {
        ...this.$utils.getSelectBackground(this.pc_widgets_infor.tabBackground),
        ...this.$utils.getSelectFontStyle(this.pc_widgets_infor.tabFont),
      }
    }
  },
  methods: {
    changeStyle(tabName) {
      this.templet.changeStyle(this.module, tabName)
    },
    onClickTabItem(tabName) {
      this.currentTab = tabName
      let $oldPanel = $(this.$refs.wrapper).find(`.tab-panel-active`)
      let $newPanel = $(this.$refs.wrapper).find(`.tab-panel-${tabName}`)
      $oldPanel.fadeOut(200, () => {
        $newPanel.fadeIn(200).addClass('tab-panel-active')
      }).removeClass('tab-panel-active')
    },
    onClickEditImgBtn() {
      this.$store.commit('image_upload/set_fileType', 1)
      this.$store.commit('image_upload/set_fileLimit', 1)
      this.$store.commit("image_upload/set_showTag", true)
      this.$store.state.image_upload.imgFile = (e) => {
        this.infor.img = e[0].filePath
      }
    },
  }

}
</script>

<style scoped lang="scss">
.main-wrapper {
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-title {
  font-size: 24px;
  color: var(--theme_color);
}

.content-wrapper {
  width: 100%;
}

.tab-nav {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.tab-item {
  padding: 8px 16px;
  font-size: 16px;
  background: #f7f7f7;
  color: var(--theme_color);
  cursor: pointer;
}

.tab-item-active {
  background: var(--theme_color);
  color: #fff;
}

.tab-panel {
  display: none;
}

.tab-panel-active {
  display: flex;
}

.img-wrapper {
  align-self: stretch;
  flex: 1;
  position: relative;

  &:hover {
    .tooptipPart {
      display: block;
    }
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_center/index.vue